var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.showofficeEditor,
        width: "1250px",
        "before-close": _vm.handleClose,
        "close-on-click-modal": false,
        "show-close": false
      }
    },
    [
      _c(
        "div",
        { staticClass: "titleI", attrs: { slot: "title" }, slot: "title" },
        [
          _c("p", [_vm._v("无需添加变量信息，发起时可以直接编辑文件内容")]),
          _c(
            "el-button",
            {
              staticClass: "edit-cancel-btn-sty",
              attrs: { size: "small" },
              on: { click: _vm.CancelSave }
            },
            [_vm._v("取消保存")]
          ),
          _c(
            "el-tooltip",
            {
              attrs: {
                effect: "dark",
                content: "完成编辑后，编辑过的内容将替换原文件中的内容。",
                placement: "left"
              }
            },
            [
              _c(
                "el-button",
                {
                  staticClass: "edit-save-btn-sty",
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.finishEdit }
                },
                [_vm._v("完成编辑")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "office-body" },
        [
          _vm.showofficeEditor
            ? _c("only-office", {
                staticClass: "office-box",
                attrs: { editor: _vm.editor.editorConfig }
              })
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3532ced2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3532ced2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/onlyOffice/editorPup.vue
// module id = xSyw
// module chunks = 0 2 3 6 7 8 12 13 14 17 26 28 32 34 52 65